import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoModelsMachineLicense,
  useFormSubmit,
} from "melco-shared-logic";
import { Formik, FormikHelpers } from "formik";
import { useQueryClient } from "react-query";
import { useState } from "react";
import { CreateMachineLicensesFormValueType } from "./CreateMachineLicensesForm";
import { DirtyFormPrompt } from "../../../../form/DirtyFormPrompt";
import { DisplayCreateMachineLicensesSummary } from "./DisplayCreateMachineLicenseSummary";
import { useCreateMachineLicensesManager } from "../../../../../hooks/machineLicenses/useCreateMachineLicensesManager";

type CreateMachineLicensesSummaryProps = {
  machineLicensesFormValues?: CreateMachineLicensesFormValueType;
  machineLicensesDisplayValues: any;
  callbackFn: (obj: any | undefined) => void;
  stepback: () => void;
};
export const CreateMachineLicensesSummary: React.FC<
  CreateMachineLicensesSummaryProps
> = ({
  stepback,
  callbackFn,
  machineLicensesFormValues,
  machineLicensesDisplayValues,
}) => {
    const [disableCreateAndSendEmailButton, setDisableCreateAndSendEmailButton] =
      useState(false);
    const queryClient = useQueryClient();
    const queryKey = "create-querylicensemanage";

    //const { t } = useTranslation();

    const createLicenseAndSendEmail: any = useCreateMachineLicensesManager();

    const handleCreateMachineLicenses = async (
      values: any,
      formikHelpers: FormikHelpers<any>,
      options: {}
    ) => {
      /**
       *   As per requirement by default we have to show Don't assign license switch button off in UI
       * but for backend we have to send true value for it.
       * so we will flip the value , whatever is shown in UI
       * if switch button off then send true
       * if switch button on then send false
       */
      // debugger;
      //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
      let newEntity:
        | ControlcenterMelcoModelsMachineLicense
        | undefined = await createLicenseAndSendEmail({
          email_address: machineLicensesFormValues?.email_address,
          product_code: machineLicensesFormValues?.product_code ?? "",
          license_key: machineLicensesFormValues?.license_key ?? "",
          number_of_machines: machineLicensesFormValues?.number_of_machines ?? 0,
          sub_type: machineLicensesFormValues?.sub_type ?? "",
          subscription_cost: machineLicensesDisplayValues?.subscription_cost,
          is_validate_only: false,
          language: machineLicensesFormValues?.language,
          melco_customer_id: machineLicensesFormValues?.melco_customer_id,
          sub_started_on: machineLicensesFormValues?.sub_started_on,
        });
      //   //console.log("newEntity",newEntity)
      console.log(newEntity);
      setDisableCreateAndSendEmailButton(false);
      callbackFn(newEntity);
    };
    const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
      setDisableCreateAndSendEmailButton(true);
      try {
        await onCreateSerialNumber(values, formikHelpers, {});
      } catch (e) {
        console.log("Exception create License summary ", e);
      } finally {
        setDisableCreateAndSendEmailButton(false);
      }
    };

    const formSubmitToCreateMachineLicenses = () => {
      return [
        async (values: any, formikHelpers: FormikHelpers<any>) => {
          //debugger;
          return handleCreateMachineLicenses(values, formikHelpers, {});
        },
        {
          //  translationPrefix: "licenses.basic.detail.Create",
          // translationOptions: {
          //   batchnumber: 1,
          //        },
          translationPrefix: ["licensemanager", "create"].join("."),
          onError: () => {
            // refetch entity from server
            queryClient.invalidateQueries(queryKey);
          },
        },
      ] as const;
    };

    const onCreateSerialNumber = useFormSubmit(
      ...formSubmitToCreateMachineLicenses()
    );

    return (
      <FullWidthSpace direction="vertical" size="large">
        <Formik initialValues={{}} onSubmit={onSubmit} enableReinitialize>
          <div>
            <DirtyFormPrompt>
              <DisplayCreateMachineLicensesSummary
                stepback={stepback}
                machineLicensesDisplayValues={machineLicensesDisplayValues}
                machineLicensesFormValues={machineLicensesFormValues}
                disableCreateAndSendEmailButton={disableCreateAndSendEmailButton}
              />
            </DirtyFormPrompt>
          </div>
        </Formik>
      </FullWidthSpace>
    );
  };
